import React from "react";
import { styled } from "@linaria/react";
import { color } from "..";
import Link from "../Link";
import t from "../i18n";
import { RestartLine } from "../IconV2/react";

const StyledRollback = styled(RestartLine)`
  width: 16px;
  height: 16px;
  margin-left: 8px;
  color: ${color.lightNitrogen500_Main};
  cursor: pointer;
`;

export default ({ ...props }) => (
  <Link {...props} title={t("rollback.title")}>
    <StyledRollback />
  </Link>
);
